import React, { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

import { TextSubtext } from '@dbt-labs/sourdough';

import { TileStatus } from '../EnvBased/DataMonitor';
import StatusIndicator from './StatusIndicator';

interface FreshnessMonitorProps {
  dataStatus: TileStatus;
  title?: string;
  subtitle?: ReactNode;
  className?: string;
}

const StatusInformation: React.FC<FreshnessMonitorProps> = ({
  dataStatus,
  title,
  subtitle,
  className,
}) => {
  return (
    <div className={twJoin('px-8')}>
      <div className={twJoin('flex py-4', className)}>
        <div className="flex-0">
          <StatusIndicator dataStatus={dataStatus} />
        </div>
        <div className="ml-2 flex-1">
          <div className="rounded-full">
            <TextSubtext
              className="block w-full text-lg/6 font-semibold"
              size="lg"
              loadingDimensions={{
                width: 200,
                height: 17,
              }}
            >
              {title}
            </TextSubtext>
          </div>
          <div className="rounded-full pt-1.5">
            <div className="text-dbt-gray space-y-1.5 text-xs">{subtitle}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusInformation;
